import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { CirclePlus, History, LayoutList, Store } from "lucide-react"
import { useNavigate, Link } from "react-router-dom";
import { MainLogo } from "modules/main/assets/main_logo"
import { NavUser } from "modules/main/components/nav-user"
import { PlusUpsellBanner } from "modules/subscription/components/PlusUpsellBanner"
import { useLists } from "modules/lists/context/ListsContext";
import { useAuth } from "modules/authentication/hooks/use-auth";
import { useSidebar } from "@/components/ui/sidebar"
import { NavItem } from "@/components/sidebar-nav-item"
import { CategoriesMenu } from "@/components/categories-menu"


export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const navigate = useNavigate();
  const { createList } = useLists();
  const { isPremiumUser } = useAuth();
  const { setOpenMobile } = useSidebar();

  const handleCreateList = async () => {
    setOpenMobile(false)
    const newList = await createList("Nueva lista", "");
    navigate(`/lists/${newList.id}`, { state: { isNew: true } });
  };

  return (
    <Sidebar collapsible="icon" className="pt-2 pb-4 px-2 bg-white">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="[&_svg]:!size-8 overflow-hidden group-data-[collapsible=icon]:mx-auto group-data-[collapsible=icon]:!p-0 group-data-[collapsible=icon]:justify-center"
            >
              <div className="flex items-center gap-2 group-data-[collapsible=icon]:justify-center">
                <Link to={"/store"} className="flex items-center gap-2 group-data-[collapsible=icon]:size-8 group-data-[collapsible=icon]:justify-center" onClick={() => setOpenMobile(false)}>
                  <MainLogo classname="size-8 shrink-0" />
                  <span className="font-bold russo-one-regular logo-text truncate mt-2 group-data-[collapsible=icon]:hidden">Carriapp</span>
                  {isPremiumUser && (
                    <span className="inline-flex h-4 items-center rounded-full border border-border/50 bg-background px-1.5 text-[10px] font-semibold leading-none group-data-[collapsible=icon]:hidden">
                      <span className="bg-[linear-gradient(90deg,#F9802D_0%,#F9802D_42%,#5CA273_100%)] bg-[length:220%_220%] bg-clip-text text-transparent animate-[ai-border-flow_8s_cubic-bezier(0.4,0,0.2,1)_infinite]">
                        +Plus
                      </span>
                    </span>
                  )}
                </Link>
              </div>
            </SidebarMenuButton>
                      </SidebarMenuItem>
        </SidebarMenu>      
      </SidebarHeader>
      <SidebarContent className="py-10 px-2">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu className="gap-3">
              <SidebarMenuItem className="flex items-center gap-4">
                <SidebarMenuButton
                  onClick={handleCreateList}
                  tooltip="Crea una lista"
                  className="min-w-8 bg-primary text-primary-foreground duration-200 ease-linear hover:bg-primary/90 hover:text-primary-foreground active:bg-primary/90 active:text-primary-foreground cursor-pointer"
                >
                  <CirclePlus />
                  <span>Crea una Lista</span>
                </SidebarMenuButton>
              </SidebarMenuItem>        
              <NavItem to="/store" icon={<LayoutList />}>Mi panel de ahorro</NavItem>
               <NavItem to="/settings/orders" icon={<History />}>Historial de compras</NavItem>
               <NavItem to="/catalog" icon={<Store />}>Catálogo</NavItem>
          </SidebarMenu>
          <CategoriesMenu />
          </SidebarGroupContent>
        </SidebarGroup>      
      </SidebarContent>
      <SidebarFooter className="px-2 flex flex-col gap-4">
        {!isPremiumUser && <PlusUpsellBanner variant="sidebar" />}
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
